/** Shared plain-object guard for JSON config/metadata parsing. */
export const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);
